(function() {
  const applyImage = (img) => {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    img.setAttribute('data-loaded', 'true');
    img.classList.add('is-loaded');
  };

  const initLazyImages = () => {
    // 只抓取带 js-lazy-load-img 类且未加载过的图片
    const images = document.querySelectorAll('img.js-lazy-load-img:not([data-loaded="true"])');
    
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            applyImage(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px 500px 0px' });

      images.forEach(img => observer.observe(img));
    } else {
      images.forEach(img => applyImage(img));
    }
  };

  // --- 关键改进：使用 MutationObserver 监听动态插入的内容 ---
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        initLazyImages(); // 发现新元素进入 DOM，重新激活懒加载
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 初次加载
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyImages);
  } else {
    initLazyImages();
  }

  // Shopify 主题编辑器支持
  document.addEventListener('shopify:section:load', initLazyImages);
})();